import { ActionStatus } from '../../enums/order/action-status.enum';

export const recipientActionStatusMapper = new Map<ActionStatus, { badgeClass: string; translationKey: string }>([
  [
    ActionStatus.Completed,
    {
      badgeClass: 'bg-success-surface text-success',
      translationKey: 'COMPLETED',
    },
  ],
  [
    ActionStatus.Pending,
    {
      badgeClass: 'bg-warning-surface text-warning-ink',
      translationKey: 'PENDING',
    },
  ],
  [
    ActionStatus.Declined,
    {
      badgeClass: 'bg-danger-soft text-danger',
      translationKey: 'DECLINED',
    },
  ],
]);
